import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { Query } from 'react-apollo';
import { GET_PRODUCTS } from 'graphql/products';
import Typography from '@material-ui/core/Typography';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Spin from '../../../components/common/Spin';
import times from 'lodash/times';

const currentyear = new Date().getFullYear();
const GRADUATION_YEARS =  times(4).map(i => ({ label: currentyear + i, value: currentyear + i }));

const PlanLabel = {
  'Tier': 'Deferred Success',
  'Recurring': 'Installment',
  'One time': 'Prepaid',
};

const useStyles = makeStyles((theme) => ({
  toggleButton: {
    display: 'flex',
    flexDirection: 'column',
    '& button': {
      marginBottom: theme.spacing(1),
      borderColor: '#ddd !important'
    }
  },
}));

const ProductSelection = ({ year, product, onChange, step }) => {
  const classes = useStyles();

  const onYearChange = (e, val) => {
    onChange('year', val)
  };

  const onProductChange = (e, val) => {
    onChange('product', val);
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {step === 1 && (
        <>
          <Typography gutterBottom variant="h5">
            Graduation Year
          </Typography>
          <Box marginTop={3} width={'60%'}>
            <ToggleButtonGroup
              exclusive
              orientation="vertical"
              onChange={onYearChange}
              value={year}
              className={classes.toggleButton}
            >
              {GRADUATION_YEARS.map((i) => (
                <ToggleButton key={i.value} value={i.value}>{i.label}</ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </>
      )}
      {step === 2 && (
        <Query query={GET_PRODUCTS} variables={{ graduation_year: year }}>
          {({ data, loading }) => {
            if (loading) return <Spin spinning />;
            const { products } = data;
            return (
              <>
                <Typography gutterBottom variant="h5">
                  Select a Plan
                </Typography>
                <Box marginTop={3} width={'60%'}>
                  <ToggleButtonGroup
                    exclusive
                    orientation="vertical"
                    onChange={onProductChange}
                    value={product}
                    className={classes.toggleButton}
                  >
                    {products.map((i) => (
                      <ToggleButton value={i}>{i.package_name} - {PlanLabel[i.pricing_model]}</ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Box>
              </>
            );
          }}
        </Query>
      )}
    </Box>
  );
};

export default ProductSelection;
